import { render, staticRenderFns } from "./OrderCurrentService.vue?vue&type=template&id=95d264b0&scoped=true"
import script from "./OrderCurrentService.vue?vue&type=script&lang=js"
export * from "./OrderCurrentService.vue?vue&type=script&lang=js"
import style0 from "./OrderCurrentService.vue?vue&type=style&index=0&id=95d264b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d264b0",
  null
  
)

export default component.exports